import LxcError from "~/core/models/LxcError.class";
import type { DelegationDetails } from "~/modules/relation/delegation/models/DelegationDetails.interface";
import delegationService from "~/modules/relation/delegation/services/delegation.service";

export function useGetDelegationDetails(organizationCode?: number) {
  const getDelegationDetailsOrganizationCode = ref(organizationCode);

  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();
  const result: Ref<DelegationDetails | undefined> = ref();

  function setOrganizationCode(organizationCode?: number) {
    getDelegationDetailsOrganizationCode.value = organizationCode;
  }

  async function getDelegationDetails(targetOrganizationCode: number) {
    isLoading.value = true;
    error.value = undefined;
    result.value = undefined;

    const response = await delegationService.getOrganizationDelegationDetails(
      targetOrganizationCode,
      getDelegationDetailsOrganizationCode.value,
    );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    isLoading,
    error,
    result,
    setOrganizationCode,
    getDelegationDetails,
  };
}
